export function initContactForm() {
  // Contact form handling with API integration
  const contactForm = document.getElementById("contact-form");
  const successMessage = document.getElementById("success-message");

  if (contactForm) {
    contactForm.addEventListener("submit", async function (e) {
      e.preventDefault();

      const submitBtn = this.querySelector('button[type="submit"]');
      const originalText = submitBtn.textContent;

      // Set loading state
      submitBtn.textContent = "Sending...";
      submitBtn.disabled = true;

      // Get form data using the proper field names
      const formData = new FormData(this);
      const firstName = formData.get("firstName");
      const lastName = formData.get("lastName");
      const company = formData.get("company");
      const email = formData.get("email");
      const phone = formData.get("phone");
      const message = formData.get("message");

      console.log("Form data:", {
        firstName,
        lastName,
        company,
        email,
        phone,
        message,
      }); // Debug log

      // Validation
      if (!firstName || !lastName || !company || !email || !phone || !message) {
        alert("Please fill in all fields");
        return;
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        alert("Please enter a valid email address");
        return;
      }

      try {
        grecaptcha.ready(function () {
          grecaptcha
            .execute("6LfuawUsAAAAACoJnwjB37b2jNspIZKZCnWcYvWf", { action: "submit" })
            .then(async function (token) {
              // Prepare data in the format expected by the API (matching old site)
              const apiData = {
                FirstName: firstName,
                LastName: lastName,
                Company: company,
                Email: email,
                Phone: phone,
                Message: message,
                Token: token,
              };

              console.log("Submitting form data:", apiData);

              // Submit to API
              const response = await fetch(
                "https://qobpvncj3a.execute-api.ap-southeast-2.amazonaws.com/contact",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(apiData),
                }
              );

              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }

              const result = await response.json();
              console.log("API response:", result);
            })
            .catch((error) => {
              throw error;
            });
        });

        // Show success message
        contactForm.style.display = "none";
        if (successMessage) {
          successMessage.classList.remove("hidden");
          successMessage.style.display = "block";
        } else {
          alert(
            "Thank you for your message! We'll get back to you soon to discuss your agentic AI project."
          );
        }
      } catch (error) {
        console.error("Form submission error:", error);
        alert("There was an error submitting your message. Please try again.");
      } finally {
        // Reset button state
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }
    });
  }
}
